import { Divider, Typography } from "@mui/material";
import { palette, spacing } from "../../../styles/theme";
import { Box, FlexColBox, CurrencySwitcher } from "../../../common/components";
import { useTranslation } from "react-i18next";
import { FormattedPrice } from "../common/types";
import { CalculatePriceModalStyles } from "../common/styles";

interface Props {
  totalPrice: FormattedPrice;
  shippingPrice: FormattedPrice;
}

const PricingSection = ({ totalPrice }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <FlexColBox gap={{ xs: spacing.xsMobile, lg: spacing.xsDesktop }}>
        <Box sx={CalculatePriceModalStyles.bottomSection}>
          <Typography variant="textRegularBold">
            {t("pricing.subtotal")}
          </Typography>
          <Typography variant="textRegularBold">
            {totalPrice.formatted}
          </Typography>
        </Box>
        <Box sx={CalculatePriceModalStyles.bottomSection}>
          <CurrencySwitcher />
          <Typography variant="textSm" color={palette.grey.nearBlack}>
            {t("pricing.taxes")}
          </Typography>
        </Box>
      </FlexColBox>
      <Divider />
    </>
  );
};

export default PricingSection;
